import * as React from "react";

interface DeprecatedBaseMarkerProps extends React.SVGProps<SVGSVGElement> {
  rotation?: number;
  moving?: boolean;
  on?: boolean;
  oldData?: boolean;
  pulse?: boolean;
  favourite?: boolean;
}

/**
 * @deprecated
 */
function SvgBaseMarker(props: DeprecatedBaseMarkerProps): React.ReactElement {
  const { moving, on, oldData, rotation, pulse, fill = "#0DA6FD", favourite, ...svgProps } = props;
  let rotate;
  if (rotation && rotation > 0 && rotation <= 360) {
    rotate = `rotate(${+rotation} 28.5 32.5)`;
  }
  return (
    <svg width="62" height="62" viewBox="0 0 62 62" fill="none" {...svgProps}>
      {on ? (
        <g>
          <circle cx="28.5" cy="32.5" r="13.5" fill={fill} fillOpacity=".2">
            {pulse && (
              <>
                <animate
                  attributeType="SVG"
                  attributeName="r"
                  begin="0s"
                  dur="1.5s"
                  repeatCount="indefinite"
                  from="5%"
                  to="25%"
                />
                <animate
                  attributeType="CSS"
                  attributeName="stroke-width"
                  begin="0s"
                  dur="1.5s"
                  repeatCount="indefinite"
                  from="3%"
                  to="0%"
                />
                <animate
                  attributeType="CSS"
                  attributeName="opacity"
                  begin="0s"
                  dur="1.5s"
                  repeatCount="indefinite"
                  from="1"
                  to="0"
                />
              </>
            )}
          </circle>
          <circle cx="28.5" cy="32.5" r="4.5" fill={fill} opacity={oldData ? 0.5 : 1} />
          <circle
            cx="28.5"
            cy="32.5"
            r="5.5"
            stroke="white"
            strokeOpacity="0.4"
            strokeWidth="2"
            opacity={oldData ? 0.5 : 1}
          />
          {moving && (
            <g transform={rotate} opacity={oldData ? 0.5 : 1}>
              <path d="M23 16L28 8L33 16L28 13.5L23 16Z" fill={fill} />
            </g>
          )}
          {favourite && (
            <>
              <g filter="url(#filter0_d)">
                <rect x="34" y="17" width="16" height="16" rx="8" fill="white" />
                <path
                  d="M42.4755 20.8455C42.4086 20.6395 42.2166 20.5 42 20.5C41.7834 20.5 41.5914 20.6395 41.5245 20.8455L40.7387 23.2639H38.1958C37.9792 23.2639 37.7872 23.4034 37.7202 23.6094C37.6533 23.8154 37.7266 24.0411 37.9019 24.1684L39.9591 25.6631L39.1733 28.0816C39.1064 28.2876 39.1797 28.5133 39.355 28.6406C39.5302 28.7679 39.7675 28.7679 39.9428 28.6406L42 27.1459L44.0572 28.6406C44.2325 28.7679 44.4698 28.7679 44.645 28.6406C44.8203 28.5133 44.8936 28.2876 44.8267 28.0816L44.0409 25.6631L46.0981 24.1684C46.2734 24.0411 46.3467 23.8154 46.2798 23.6094C46.2128 23.4034 46.0208 23.2639 45.8042 23.2639H43.2613L42.4755 20.8455Z"
                  fill="#FFC700"
                  stroke="#FFC700"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d"
                  x="32"
                  y="17"
                  width="20"
                  height="20"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                  <feOffset dy="2" />
                  <feGaussianBlur stdDeviation="1" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
              </defs>
            </>
          )}
        </g>
      ) : (
        <g>
          <rect x="22" y="21" width="18" height="19" fill="#232A3C" opacity={oldData ? 0.05 : 0.1} />
          <g opacity={oldData ? 0.2 : 0.5}>
            <rect x="28" y="27" width="7" height="7" fill={fill} />
            <rect x="27" y="26" width="9" height="9" stroke="white" strokeOpacity="0.4" strokeWidth="2" />
          </g>
          {favourite && (
            <>
              <g filter="url(#filter0_d)">
                <rect x="37" y="16" width="16" height="16" rx="8" fill="white" />
                <path
                  d="M45.4755 19.8455C45.4086 19.6395 45.2166 19.5 45 19.5C44.7834 19.5 44.5914 19.6395 44.5245 19.8455L43.7387 22.2639H41.1958C40.9792 22.2639 40.7872 22.4034 40.7202 22.6094C40.6533 22.8154 40.7266 23.0411 40.9019 23.1684L42.9591 24.6631L42.1733 27.0816C42.1064 27.2876 42.1797 27.5133 42.355 27.6406C42.5302 27.7679 42.7675 27.7679 42.9428 27.6406L45 26.1459L47.0572 27.6406C47.2325 27.7679 47.4698 27.7679 47.645 27.6406C47.8203 27.5133 47.8936 27.2876 47.8267 27.0816L47.0409 24.6631L49.0981 23.1684C49.2734 23.0411 49.3467 22.8154 49.2798 22.6094C49.2128 22.4034 49.0208 22.2639 48.8042 22.2639H46.2613L45.4755 19.8455Z"
                  fill="#FFC700"
                  stroke="#FFC700"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <filter
                  id="filter0_d"
                  x="35"
                  y="16"
                  width="20"
                  height="20"
                  filterUnits="userSpaceOnUse"
                  colorInterpolationFilters="sRGB"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" />
                  <feOffset dy="2" />
                  <feGaussianBlur stdDeviation="1" />
                  <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                  <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
                  <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
                </filter>
              </defs>
            </>
          )}
        </g>
      )}
    </svg>
  );
}

export default SvgBaseMarker;
